import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { MAIN_CONTENT_DATA_WRAPPER_SETTINGS } from '../../globals';
import DataWrapper from '../../common/DataWrapper/DataWrapper';
import Chart from '../../common/Chart/Chart';
import { formatterTimes } from '../../common/Chart/utils';

import { StyledCharts } from './styles/StyledCharts';



const showWeekDay = (day) => {
  switch(day) {
    case 0:
      return 'Pondělí';
    case 1:
      return 'Úterý';
    case 2:
      return 'Středa';
    case 3:
      return 'Čtvrtek';
    case 4:
      return 'Pátek';
    case 5:
      return 'Sobota';
    case 6:
      return 'Neděle';
    default:
      return null;
  }
}


class Charts extends Component {
  render() {
    const { statsData, statsType, maxValue, dateChecked, selected, year, month,} = this.props;

    let isRenderedChart = false;

    return (
      <StyledCharts>
        <DataWrapper
          isLoading={statsData.isLoading}
          status={statsData.status}
          minHeight={250}
          isLoadingText="Načítají se statistiky"
          errorMessage="Nepodařilo se načíst statistiky. Zkuste prosím stránku načíst znovu, nebo opakujte akci později."
          spinnerFat={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.spinnerFat} 
          spinnerSize={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.spinnerSize} 
          textSizeLoading={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.textSizeLoading}
          textSizeError={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.textSizeError}
        >
          { statsData.data.stats.map((graphData, index) => {

            if (graphData === null) {
              return null;
            }
            else {
              isRenderedChart = true;
              return (
                <div className="officestats-charts"
                  key={'chart-' + index}
                >
                  <Chart
                    data={graphData[statsType].slice()}
                    labels={graphData.labels.slice()}
                    yMax={statsData.data[maxValue]}
                    formatter={statsType === 'avg_time' ? formatterTimes : null}
                    selected={dateChecked === 'year' ? selected.day === index && selected.year === year : selected.day === index && selected.month === month && selected.year === year}
                  />
                  <div className="officestats-charts-title">
                    {showWeekDay(index)}
                  </div>
                </div>
              );
            }
          })}

          { !isRenderedChart &&
            <div className="officestats-nodata">
              <div className="officestats-nodata-icon">
                <i className="fa fa-bar-chart" aria-hidden="true"></i>
              </div>
              <div className="officestats-nodata-text">
                Statistiky nejsou momentálně k dispozici
              </div>
            </div>
          }

        </DataWrapper>
      </StyledCharts>
    );
  }
}


Charts.propTypes = {
  year: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
  dateChecked: PropTypes.string.isRequired,
  statsData: PropTypes.object.isRequired,
  statsType: PropTypes.string.isRequired,
  maxValue:  PropTypes.string.isRequired,
  selected: PropTypes.object.isRequired,
};


export default Charts;